<template>
    <TransitionRoot appear :show="scanner.camera_failded" as="template">
        <Dialog as="div" @close="closeModal" class="relative z-10">
            <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0" enter-to="opacity-100"
                leave="duration-200 ease-in" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-black bg-opacity-25" />
            </TransitionChild>

            <div class="fixed inset-0 overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center">
                    <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0 scale-95"
                        enter-to="opacity-100 scale-100" leave="duration-200 ease-in" leave-from="opacity-100 scale-100"
                        leave-to="opacity-0 scale-95">
                        <DialogPanel
                            class="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                            <DialogTitle as="h3" class="text-xl text-center font-medium leading-6 text-gray-900">
                                Oops
                            </DialogTitle>
                            <div class="mt-2 text-center">
                                <DeviceComputerCameraOffIcon class="mx-auto mb-4" size="32" />
                                <p class="text-base text-gray-500" v-html="dataLocale.data.t1">

                                </p>

                                <p class="text-base text-gray-500" v-html="dataLocale.data.t2">

                                </p>

                            </div>
                            <div class="mt-4 flex items-center justify-center">
                                <button type="button"
                                    class="inline-flex justify-center rounded-md border border-transparent bg-gray-200 px-4 py-2 text-sm font-medium text-black hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                    @click="closeModal">
                                    {{ $t('close') }}
                                </button>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script lang="ts" setup>
import {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogPanel,
    DialogTitle,
} from '@headlessui/vue'
import { DeviceComputerCameraOffIcon } from "vue-tabler-icons"
import DataLocale from '~~/config/interface/DataLocale';
import { useScanner } from '~~/stores/scanner';

const dataLocale = new DataLocale([
    {
        locale: "en",
        t1: "No camera detected",
        t2: "Please use another way to decode."
    },
    {
        "locale": "vi",
        "t1": "Không tìm thấy máy ảnh",
        "t2": "Vui lòng sử dụng cách khác để giải mã."
    }
    ,
    {
        "locale": "es",
        "t1": "Cámara no detectada",
        "t2": "Por favor, utiliza otra forma para decodificar."
    }
    ,
    {
        "locale": "fr",
        "t1": "Aucune caméra détectée",
        "t2": "Veuillez utiliser un autre moyen pour décoder."
    }
    ,
    {
        "locale": "it",
        "t1": "Nessuna fotocamera rilevata",
        "t2": "Si prega di utilizzare un altro modo per decodificare."
    }
    ,
    {
        "locale": "nl",
        "t1": "Geen camera gedetecteerd",
        "t2": "Gebruik alstublieft een andere manier om te decoderen."
    }
    ,
    {
        "locale": "ja",
        "t1": "カメラが検出されません",
        "t2": "別の方法でデコードしてください。"
    }
    ,
    {
        "locale": "pt",
        "t1": "Nenhuma câmera detectada",
        "t2": "Por favor, use outro modo para decodificar."
    }
    ,
    {
        "locale": "zh",
        "t1": "未检测到摄像头",
        "t2": "请使用其他方式进行解码。"
    },
    {
        "locale": "de",
        "t1": "Keine Kamera erkannt",
        "t2": "Bitte verwenden Sie einen anderen Weg zum Decodieren."
    }
])

const scanner = useScanner()
const closeModal = () => {
    scanner.camera_failded = false
}
const openModal = () => {
    scanner.camera_failded = true
}
</script>